import { Link, Outlet, useLocation } from 'react-router-dom';
import { Logo } from './Logo';

export function Layout() {
  const location = useLocation();
  const isPricing = location.pathname === '/pricing';

  return (
    <div className="bg-grid min-h-screen flex flex-col">
      <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-ll-bg/80 border-b border-ll-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
          <Logo />
          <nav className="flex items-center gap-6">
            <Link
              to="/pricing"
              className="text-sm text-ll-muted hover:text-ll-text transition-colors"
            >
              Pricing
            </Link>
            <a href="#" className="text-sm text-ll-muted hover:text-ll-text transition-colors">
              Docs
            </a>
            <Link
              to="/sign-in"
              className="text-sm text-ll-cyan hover:brightness-110 transition-colors"
            >
              Sign In
            </Link>
          </nav>
        </div>
      </header>

      <main
        className={`flex-1 flex ${
          isPricing ? 'items-start' : 'items-center'
        } justify-center pt-14 min-h-screen`}
      >
        <Outlet />
      </main>

      <footer className="text-center text-ll-muted text-sm py-8">
        &copy; {new Date().getFullYear()} LayerLint. All rights reserved.
      </footer>
    </div>
  );
}
